import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  IconButton,
  InputLabel,
  TextField,
  Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import { useDispatch, useSelector } from "react-redux";
import { addChildFolder } from "../../../../redux/docs";
import { toast } from "react-toastify";
import LoadingButton from "@mui/lab/LoadingButton";
function NewFolder(props) {
  const { open, setOpen, classes, id } = props;
  const [folderName, setFolderName] = useState("");
  const dispatch = useDispatch();
  const childFolder = useSelector((state) => state.Docs.childFolder);

  const handleAddChildFolder = () => {
    if (folderName.trim() === "") {
      toast.error("Please enter a folder name", { theme: "colored" });
      return;
    }
    dispatch(
      addChildFolder({
        schema: {
          parent_id: id,
          name: folderName,
        },
        handleSuccess: () => {
          handleClose();
          toast.success("Folder created successfully", { theme: "colored" });
        },
        handleError: (error) => {
          toast.error(JSON.stringify(error), { theme: "colored" });
        },
      })
    );
  };
  const handleClose = () => {
    setOpen(false);
    setFolderName("");
  };

  return (
    <Fragment>
      <Dialog disablePortal open={open} fullWidth={true} maxWidth={"sm"}>
        <DialogTitle className={classes.modalHeader}>
          <Typography className={classes.modalTitle}> New Folder</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <InputLabel className={classes.inputLabel}>
            Give this folder a name
          </InputLabel>
          <Grid container spacing={3}>
            <Grid item xs={1}>
              <FolderRoundedIcon
                sx={{ mt: "5px", color: "#757575", fontSize: "28px" }}
              />
            </Grid>
            <Grid item xs={11}>
              <TextField
                fullWidth
                size="small"
                className={classes.EditMlsField}
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding: "10px  20px 20px 0px" }}>
          <Button onClick={handleClose} className={classes.cancelButton}>
            Cancel
          </Button>
          <LoadingButton
            disabled={!Boolean(folderName)}
            className={classes.doneButton}
            onClick={() => handleAddChildFolder()}
            loading={childFolder.isLoading}
            loadingPosition="end"
          >
            Done
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
export default withStyles(styleSheet, { name: "NewFolderStyle" })(NewFolder);
